import { type PropsWithChildren } from 'react';
import { useAudio } from '../../hooks/useAudio';
import { AudioContext } from './context';

export const AudioProvider = ({ children }: PropsWithChildren<unknown>) => {
    const audio = useAudio();

    return <AudioContext.Provider value={audio}>{children}</AudioContext.Provider>;
};
